
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watchlists",
      function () {
        return require("private-next-pages/watchlists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watchlists"])
      });
    }
  